module.exports = __webpack_public_path__ + "static/media/iphone-x-graphs-reduced.1556f4bb.png";